import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from 'app/common/presentation'
import { ShopifyConnection, isInstalledConnection } from 'app/connections/types'

import styles from './Settings.module.scss'
import { DangerZone, SettingsSection } from './components'

interface ShopifySettingsProps {
  connection: ShopifyConnection
  onConnectionConfigValidationUpdate: (isValidConfig: boolean) => void
  onShopUpdate: (shop: string) => void
}

const ShopifySettings = ({
  connection,
  onConnectionConfigValidationUpdate,
  onShopUpdate,
}: ShopifySettingsProps) => {
  const { t } = useTranslation('connections')

  const currentShop = connection.config.shops[0]?.name ?? ''

  const [shop, setShop] = useState<string>(currentShop)

  useEffect(() => {
    onShopUpdate(shop.trim())
    onConnectionConfigValidationUpdate(shop.trim().length > 0 && shop.trim() !== currentShop)
  }, [currentShop, onConnectionConfigValidationUpdate, onShopUpdate, shop])

  return (
    <>
      <SettingsSection
        contentClassName={styles.basicCard}
        description={t('setup.basics.description')}
        title={t('setup.basics.title')}
      >
        <Form.InputFormRow
          description={t(`setup.${connection.name}.config.shop.description`)}
          onChange={setShop}
          placeholder={t(`setup.${connection.name}.config.shop.title`)}
          title={t(`setup.${connection.name}.config.shop.title`)}
          value={shop}
        />
      </SettingsSection>
      {isInstalledConnection(connection) && <DangerZone connection={connection} />}
    </>
  )
}

export default ShopifySettings
